import { useContext } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FormProvider, Controller } from "react-hook-form";
import { TextInput } from "src/app/@core/forms/controls/textInput";
import { DomainContext } from "src/app/@core/@contexts/domain.context";
import { ModuleContext } from "src/app/@core/@contexts/module.context";
import { CheckBox } from "src/app/@core/forms/controls/checkbox";
import { DialogHeaderContent } from "src/app/@core/forms/controls/dialogHeaderContent";

/**
 *
 * @param {*} props
 * @returns
 */
export const RetailerEdit = (props) => {
  const { open, setOpen, currentObj } = props;
  const { api, dropdown, spinner } = useContext(DomainContext);
  const { comments, frmModel, loadModelDataFunc } = useContext(ModuleContext);

  const { control, getValues, formState, handleSubmit } = frmModel();

  /**
   *
   */
  const onClose = () => {
    setOpen(false);
  };

  /**
   *
   */
  const onSubmit = async (data) => {
    try {
      spinner.show();
      const newData = data;
      const obj = { ...currentObj, ...newData };
      await api.retailerApi.update(newData);
      await loadModelDataFunc();
    } catch (err) {
      console.error(err);
    }
    onClose();
    spinner.hide();
  };

  return (
    <Dialog
      fullScreen
      style={{ margin: "auto", maxWidth: 400, maxHeight: 500 }}
      open={open}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <DialogHeaderContent title="Edit Retailer" onClose={onClose} />
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} className="dialog-form_inner">
        <DialogContent dividers={true}>
          <FormProvider {...frmModel()}>
            <div className="flex flex-col" style={{ marginRight: 20 }}>
              <TextInput
                id="retailerName"
                label="Retailer Name"
                rules={{ required: "Retailer Name is required" }}
                control={control}
              />
              <TextInput
                id="retailerShortName"
                label="Retailer Short Name"
                rules={{ required: "Retailer Short Name is required" }}
                control={control}
              />
              <TextInput
                id="retailerCity"
                label="City"
                rules={{ required: "City is required" }}
                control={control}
              />
              <TextInput
                id="retailerState"
                label="State"
                rules={{ required: "State is required" }}
                control={control}
              />
              <div
                className="flex -mx-4"
                style={{ marginLeft: 10, marginTop: 10 }}
              >
                <CheckBox id="isActive" label="Active" control={control} />
              </div>
            </div>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
